import {DataSourceMapping} from "../Catalog/DataSourceMapping";

export class ManufacturerMapping {
  constructor(
    public id: string,
    public containerId: string,
    public catalogId: string,
    public dataSourceMapping: DataSourceMapping,
  ) {}
}
